<template>
	<div>
		<login-per></login-per>
		<!-- <login-per v-if="isJapi"></login-per>
		<login-ecu v-else></login-ecu> -->
	</div>
</template>

<script>
	// import loginEcu from '@/components/login/login-ecu';
	import loginPer from '@/components/login/login-per';

	// function isJapi() {
	// 	return process.env.COUNTRY_CODE === 'PER';
	// }

	export default {
		name: 'login',
		components: {
			loginPer,
			// loginEcu,
		},
		// computed: {
		// 	isJapi,
		// },
	};
</script>



// WEBPACK FOOTER //
// src/components/login.vue